import { render, staticRenderFns } from "./TaxonomySingleTreeRelations.vue?vue&type=template&id=5a1ac184&"
import script from "./TaxonomySingleTreeRelations.vue?vue&type=script&lang=js&"
export * from "./TaxonomySingleTreeRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports